import { __assign, __rest } from "tslib";
import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import { getBaseProps } from '../internal/base-component';
import { warnOnce } from '../internal/logging';
import styles from './styles.css.js';
import icons from './icons';
import mergeRefs from 'react-merge-refs';
import { useVisualRefresh } from '../internal/hooks/use-visual-mode';
function iconSizeMap(height) {
    if (height) {
        if (height >= 50) {
            return 'large';
        }
        else if (height >= 36) {
            return 'big';
        }
        else if (height >= 24) {
            return 'medium';
        }
        else if (height <= 16) {
            return 'small';
        }
        else {
            return 'normal';
        }
    }
}
var InternalIcon = function (_a) {
    var name = _a.name, _b = _a.size, size = _b === void 0 ? 'normal' : _b, _c = _a.variant, variant = _c === void 0 ? 'normal' : _c, url = _a.url, alt = _a.alt, svg = _a.svg, badge = _a.badge, _d = _a.__internalRootRef, __internalRootRef = _d === void 0 ? null : _d, props = __rest(_a, ["name", "size", "variant", "url", "alt", "svg", "badge", "__internalRootRef"]);
    var iconRef = useRef(null);
    useVisualRefresh(iconRef);
    var _e = useState(0), parentHeight = _e[0], setParentHeight = _e[1];
    var contextualSize = size === 'inherit';
    var iconSize = contextualSize ? iconSizeMap(parentHeight) : size;
    var inlineStyles = { height: contextualSize ? parentHeight + "px" : '' };
    var baseProps = getBaseProps(props);
    baseProps.className = clsx(baseProps.className, styles.icon, contextualSize && styles['icon-flex-height'], badge && styles.badge, !contextualSize && styles["size-" + iconSize + "-mapped-height"], styles["size-" + iconSize], styles["variant-" + variant]);
    useEffect(function () {
        if (!contextualSize || !iconRef.current) {
            return;
        }
        var lineHeight = getComputedStyle(iconRef.current).lineHeight;
        var newParentHeight = parseInt(lineHeight, 10);
        setParentHeight(newParentHeight);
    });
    if (svg) {
        if (url) {
            warnOnce('Icon', 'You have specified both `url` and `svg`. `svg` will take precedence and `url` will be ignored.');
        }
        return (React.createElement("span", __assign({}, baseProps, { ref: mergeRefs([iconRef, __internalRootRef]), "aria-hidden": "true", style: inlineStyles }), svg));
    }
    if (url) {
        return (React.createElement("span", __assign({}, baseProps, { ref: mergeRefs([iconRef, __internalRootRef]), style: inlineStyles }),
            React.createElement("img", { src: url, alt: alt })));
    }
    var validIcon = name && Object.prototype.hasOwnProperty.call(icons, name);
    return (React.createElement("span", __assign({}, baseProps, { dangerouslySetInnerHTML: validIcon ? { __html: icons[name] } : undefined, ref: mergeRefs([iconRef, __internalRootRef]), style: inlineStyles })));
};
export default InternalIcon;
